import { c as _c } from "react/compiler-runtime";
import { CommunityMemberOverview, CIC_TO_TEXT } from "@/entities/IProfile";
import { formatNumberWithCommasOrDash, cicToType } from "@/helpers/Helpers";
import UserLevel from "@/components/user/utils/level/UserLevel";
import { Tooltip } from "react-tooltip";
import UserCICTypeIcon from "@/components/user/utils/user-cic-type/UserCICTypeIcon";
import { isEthereumAddress } from "@/helpers/AllowlistToolHelpers";
import { ImageScale, getScaledImageUri } from "@/helpers/image.helpers";
import CommonTimeAgo from "@/components/utils/CommonTimeAgo";
import Link from "next/link";
export default function CommunityMembersTableRow(t0) {
  const $ = _c(64);
  const {
    member,
    rank
  } = t0;
  const isNotProfile = isEthereumAddress(member.detail_view_key);
  const isProfile = !isNotProfile;
  const textColorClass = isProfile ? "tw-text-iron-50" : "tw-text-iron-400";
  const path = `/${member.detail_view_key}`;
  let t1;
  if ($[0] !== rank) {
    t1 = <td className="tw-px-4 sm:tw-pl-6 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-base tw-font-medium tw-text-iron-400">{rank}</td>;
    $[0] = rank;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `tw-group tw-pr-4 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-base tw-font-medium ${textColorClass}`;
  let t3;
  if ($[2] !== member.pfp) {
    t3 = member.pfp && <img src={getScaledImageUri(member.pfp, ImageScale.W_AUTO_H_50)} alt="Network Table Profile Picture" className="tw-bg-transparent tw-max-w-full tw-max-h-full tw-h-auto tw-w-auto tw-mx-auto tw-object-contain" />;
    $[2] = member.pfp;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="tw-h-8 tw-w-8 tw-rounded-md tw-overflow-hidden tw-ring-1 tw-ring-white/10 tw-bg-iron-900"><div className="tw-h-full tw-w-full tw-max-w-full"><div className="tw-h-full tw-text-center tw-flex tw-items-center tw-justify-center">{t3}</div></div></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `tw-truncate tw-max-w-[8rem] sm:tw-max-w-xs ${textColorClass}`;
  const t6 = `tw-no-underline group-hover:tw-underline group-hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out ${textColorClass}`;
  let t7;
  if ($[6] !== member.display || $[7] !== path || $[8] !== t6) {
    t7 = <Link href={path} className={t6}>{member.display}</Link>;
    $[6] = member.display;
    $[7] = path;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t8) {
    t9 = <div className="tw-flex tw-gap-x-4 tw-items-center">{t4}{t8}</div>;
    $[13] = t4;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t2 || $[17] !== t9) {
    t10 = <td className={t2}>{t9}</td>;
    $[16] = t2;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = `tw-px-4 sm:tw-px-6 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-base tw-font-medium  ${isNotProfile ? "tw-opacity-50" : ""}`;
  let t12;
  if ($[19] !== member.level) {
    t12 = <UserLevel level={member.level} size="sm" />;
    $[19] = member.level;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = <td className={t11}>{t12}</td>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = `tw-px-4 sm:tw-px-6 tw-text-right tw-tabular-nums tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-base tw-font-medium ${textColorClass}`;
  let t15;
  if ($[24] !== member.tdh) {
    t15 = formatNumberWithCommasOrDash(member.tdh);
    $[24] = member.tdh;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14 || $[27] !== t15) {
    t16 = <td className={t14}>{t15}</td>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  const t17 = `tw-px-4 sm:tw-px-6 tw-text-right tw-tabular-nums tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-base tw-font-medium ${textColorClass}`;
  let t18;
  if ($[29] !== member.rep) {
    t18 = formatNumberWithCommasOrDash(member.rep);
    $[29] = member.rep;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t17 || $[32] !== t18) {
    t19 = <td className={t17}>{t18}</td>;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  const t20 = `tw-px-4 tw-text-right tw-tabular-nums tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-base tw-font-medium ${textColorClass}`;
  let t21;
  if ($[34] !== member.cic) {
    t21 = formatNumberWithCommasOrDash(member.cic);
    $[34] = member.cic;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  const t22 = `cic-tooltip-${member.detail_view_key}`;
  let t23;
  if ($[36] !== member.cic) {
    t23 = <UserCICTypeIcon cic={member.cic} />;
    $[36] = member.cic;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t22 || $[39] !== t23) {
    t24 = <div className="tw-h-5 tw-w-5" data-tooltip-id={t22}>{t23}</div>;
    $[38] = t22;
    $[39] = t23;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  const t25 = `cic-tooltip-${member.detail_view_key}`;
  let t26;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  const t27 = CIC_TO_TEXT[cicToType(member.cic)];
  let t28;
  if ($[42] !== t25 || $[43] !== t27) {
    t28 = <Tooltip id={t25} place="top" style={t26}>{t27}</Tooltip>;
    $[42] = t25;
    $[43] = t27;
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  let t29;
  if ($[45] !== t21 || $[46] !== t24 || $[47] !== t28) {
    t29 = <div className="tw-flex tw-items-center tw-justify-end tw-gap-x-2">{t21}{t24}{t28}</div>;
    $[45] = t21;
    $[46] = t24;
    $[47] = t28;
    $[48] = t29;
  } else {
    t29 = $[48];
  }
  let t30;
  if ($[49] !== t20 || $[50] !== t29) {
    t30 = <td className={t20}>{t29}</td>;
    $[49] = t20;
    $[50] = t29;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== member.last_activity) {
    t31 = member.last_activity && <CommonTimeAgo timestamp={member.last_activity} />;
    $[52] = member.last_activity;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  let t32;
  if ($[54] !== t31) {
    t32 = <td className="tw-px-4 sm:tw-pr-6 tw-whitespace-nowrap tw-group tw-py-3">{t31}</td>;
    $[54] = t31;
    $[55] = t32;
  } else {
    t32 = $[55];
  }
  let t33;
  if ($[56] !== t1 || $[57] !== t10 || $[58] !== t13 || $[59] !== t16 || $[60] !== t19 || $[61] !== t30 || $[62] !== t32) {
    t33 = <tr className="even:tw-bg-iron-900 tw-cursor-pointer tw-transition tw-duration-300 tw-ease-out">{t1}{t10}{t13}{t16}{t19}{t30}{t32}</tr>;
    $[56] = t1;
    $[57] = t10;
    $[58] = t13;
    $[59] = t16;
    $[60] = t19;
    $[61] = t30;
    $[62] = t32;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  return t33;
}